import { render, staticRenderFns } from "./shopping-cart.vue?vue&type=template&id=fd42a160&scoped=true"
import script from "./shopping-cart.vue?vue&type=script&lang=js"
export * from "./shopping-cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd42a160",
  null
  
)

export default component.exports